import { buildLiveMatchDocument } from "../../session/matchDocumentHelpers";
import * as liveMatchRepository from "../../../repositories/liveMatchRepository";
import { isCmoeV1CompatibilityMirrorEnabled } from "./mirrorConfig";

/**
 * Mirror activity runtime state to V1 `liveMatches/{roomMatchId}` (write-only compat).
 */
export async function mirrorActivityToV1LiveMatch({
  roomCode,
  roomMatchId,
  managingUid,
  livePayload,
}) {
  if (!isCmoeV1CompatibilityMirrorEnabled()) return;
  const liveDocId = roomMatchId;
  const existingLive = await liveMatchRepository.fetchLiveMatch(liveDocId);
  const liveDoc = buildLiveMatchDocument(
    roomCode,
    managingUid,
    livePayload,
    existingLive,
    roomMatchId
  );
  if (!existingLive) await liveMatchRepository.createLiveMatch(liveDocId, liveDoc);
  else await liveMatchRepository.updateLiveMatch(liveDocId, liveDoc);
}
